import React, { Component } from 'react';
import { connect } from 'react-redux';
import ContactModal from "./ContactModal/ContactModal";

class Modals extends Component {
    render() {
        return (
            <div>
                {/* List of modals go here */}
                { this.props.visibility.displayContactModal === true && <ContactModal/>}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        visibility: state.visibility
    };
};

export default connect(mapStateToProps) ( Modals );